import { Box, Typography, useTheme } from '@mui/material';
import { generateSourceHandleId } from '@utils/flows';
import React from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { ITaskNodeData } from 'types/flows';
import { ITheme } from 'types/theme';

const StartNode = ({ id, data }: NodeProps<ITaskNodeData>) => {
	const theme = useTheme<ITheme>();

	const isConnected = !!data.interactions?.[0]?.nextTask;
	return (
		<Box
			p={1}
			pl={2}
			pr={2}
			data-testid={`node-${id}`}
			bgcolor={theme.palette.text.secondary}
			sx={{ width: 'fit-content' }}
			borderRadius={6}
		>
			<Handle
				type="source"
				position={Position.Right}
				data-testid={generateSourceHandleId(id, '')}
				id={generateSourceHandleId(id, '')}
				style={{
					width: '25%',
					height: '100%',
					cursor: isConnected ? 'default' : 'crosshair',
					pointerEvents: isConnected ? 'none' : 'all',
					border: 0,
					background: 'none'
				}}
			>
				<Box
					width={6}
					height={6}
					bgcolor={theme.palette.text.disabled}
					borderRadius="100%"
					sx={{
						pointerEvents: 'none',
						right: 0,
						top: '50%',
						marginTop: '-3px',
						position: 'absolute'
					}}
				/>
			</Handle>
			<Typography
				variant="body1"
				color="background.paper"
				textTransform="uppercase"
			>
				{intl.tr('flows.builder.start.task.label')}
			</Typography>
		</Box>
	);
};

export default StartNode;
